import { SideKey } from "../components/InspectionTable";

export const partsKeysList: Record<string, string> = {
  "Quarter-Panel_Right-Side": "Quarter-Panel_Right-Side",
  "Quarter-Panel_Left-Side": "Quarter-Panel_Left-Side",
  "Fender_Right-Side": "Fender_Right-Side",
  "Fender_Left-Side": "Fender_Left-Side",
  Roof: "Roof",
  "Side-Bumper_Rear-Left-Side": "Side-Bumper_Rear-Left-Side",
  "Side-Bumper_Rear-Right-Side": "Side-Bumper_Rear-Right-Side",
  "Side-Bumper_Front-Right-Side": "Side-Bumper_Front-Right-Side",
  "Side-Bumper_Front-Left-Side": "Side-Bumper_Front-Left-Side",
  Spoiler: "Spoiler",
  Trunk: "Trunk",
  Hood: "Hood",
  "Tail-Light_Right-Side": "Tail-Light_Right-Side",
  "Bumper_Rear-Side": "Bumper_Rear-Side",
  "Bumper_Front-Side": "Bumper_Front-Side",
  "Tail-Light_Left-Side": "Tail-Light_Left-Side",
  "Door_Rear-Right-Side": "Door_Rear-Right-Side",
  "Door_Front-Right-Side": "Door_Front-Right-Side",
  "Door_Rear-Left-Side": "Door_Rear-Left-Side",
  "Door_Front-Left-Side": "Door_Front-Left-Side",
  "Wheel_Front-Right-Side": "Wheel_Front-Right-Side",
  "Wheel_Rear-Right-Side": "Wheel_Rear-Right-Side",
  "Wheel_Front-Left-Side": "Wheel_Front-Left-Side",
  "Wheel_Rear-Left-Side": "Wheel_Rear-Left-Side",
  "Windshield_Front-Side": "Windshield_Front-Side",
  "Windshield_Rear-Side": "Windshield_Rear-Side",
  "Side-Rocker-Panel_Right-Side": "Side-Rocker-Panel_Right-Side",
  "Side-Rocker-Panel_Left-Side": "Side-Rocker-Panel_Left-Side",
  "Window_Front-Right-Side": "Window_Front-Right-Side",
  "Alloy-Rim_Front-Right-Side": "Alloy-Rim_Front-Right-Side",
  "Alloy-Rim_Rear-Right-Side": "Alloy-Rim_Rear-Right-Side",
  "Arch-Panel_Front-Right-Side": "Arch-Panel_Front-Right-Side",
  "Arch-Panel_Rear-Right-Side": "Arch-Panel_Rear-Right-Side",
  "Window_Rear-Right-Side": "Window_Rear-Right-Side",
  "Exterior-Door-Handle_Front-Right-Side":
    "Exterior-Door-Handle_Front-Right-Side",
  "Wiper_Front-Side": "Wiper_Front-Side",
  "Wiper_Rear-Side": "Wiper_Rear-Side",
  "Roof-Rail_Right-Side": "Roof-Rail_Right-Side",
  "Roof-Rail_Left-Side": "Roof-Rail_Left-Side",
  "Molding_Left-Side": "Molding_Left-Side",
  "Molding_Right-Side": "Molding_Right-Side",
  "Exterior-Door-Handle_Rear-Right-Side":
    "Exterior-Door-Handle_Rear-Right-Side",
  "Quarter-Glass_Right-Side": "Quarter-Glass_Right-Side",
  "Window_Front-Left-Side": "Window_Front-Left-Side",
  "Alloy-Rim_Front-Left-Side": "Alloy-Rim_Front-Left-Side",
  "Side-Mirror_Left-Side": "Side-Mirror_Left-Side",
  "Side-Mirror_Right-Side": "Side-Mirror_Right-Side",
  "Alloy-Rim_Rear-Left-Side": "Alloy-Rim_Rear-Left-Side",
  "Arch-Panel_Front-Left-Side": "Arch-Panel_Front-Left-Side",
  "Arch-Panel_Rear-Left-Side": "Arch-Panel_Rear-Left-Side",
  "Window_Rear-Left-Side": "Window_Rear-Left-Side",
  "Exterior-Door-Handle_Front-Left-Side":
    "Exterior-Door-Handle_Front-Left-Side",
  "Exterior-Door-Handle_Rear-Left-Side": "Exterior-Door-Handle_Rear-Left-Side",
  "Quarter-Glass_Left-Side": "Quarter-Glass_Left-Side",
  "Head-Light_Right-Side": "Head-Light_Right-Side",
  "Head-Light_Left-Side": "Head-Light_Left-Side",
  "Grille_Front-Side": "Grille_Front-Side",
  "Grille_Rear-Side": "Grille_Rear-Side",
  "Brake-Light": "Brake-Light",
  "License-Plate": "License-Plate",
  "Fuel-Cap": "Fuel-Cap",
  "Logo_Front-Side": "Logo_Front-Side",
  "Logo_Rear-Side": "Logo_Rear-Side",
  "Fog-Light_Rear-Left-Side": "Fog-Light_Rear-Left-Side",
  "Fog-Light_Front-Left-Side": "Fog-Light_Front-Left-Side",
  "Fog-Light_Rear-Right-Side": "Fog-Light_Rear-Right-Side",
  "Fog-Light_Front-Right-Side": "Fog-Light_Front-Right-Side",
  Antenna: "Antenna",
  "Indicator-Light_Right-Side": "Indicator-Light_Right-Side",
  "Indicator-Light_Left-Side": "Indicator-Light_Left-Side",
};
export const apiToDisplayMap: Record<string, string> = {
  // Left Side
  "Door_Rear-Left-Side": "Rear door",
  "Door_Front-Left-Side": "Front door",
  "Side-Mirror_Left-Side": "Side mirror",
  "Window_Front-Left-Side": "Front window",
  "Window_Rear-Left-Side": "Rear window",
  // "Alloy-Rim_Front-Left-Side": "Front alloy rim",
  // "Alloy-Rim_Rear-Left-Side": "Rear alloy rim",
  // "Wheel_Front-Left-Side": "Front wheel",
  // "Wheel_Rear-Left-Side": "Rear wheel",
  "Arch-Panel_Front-Left-Side": "Front arch panel",
  "Arch-Panel_Rear-Left-Side": "Rear arch panel",
  "Exterior-Door-Handle_Front-Left-Side": "Front door handle",
  "Exterior-Door-Handle_Rear-Left-Side": "Rear door handle",
  "Quarter-Glass_Left-Side": "Quarter glass",
  "Side-Rocker-Panel_Left-Side": "Side rocker panel",
  "Molding_Left-Side": "Moldings",
  "Roof-Rail_Left-Side": "Roof rail",
  "Indicator-Light_Left-Side": "Indicator light",
  "Side-Bumper_Front-Left-Side": "Front side bumper",
  "Side-Bumper_Rear-Left-Side": "Rear side bumper",
  "Fender_Left-Side": "Fender",
  "Quarter-Panel_Left-Side": "Quarter panel",

  // Right Side
  "Door_Rear-Right-Side": "Rear door",
  "Door_Front-Right-Side": "Front door",
  "Side-Mirror_Right-Side": "Side mirror",
  "Window_Front-Right-Side": "Front window",
  "Window_Rear-Right-Side": "Rear window",
  "Alloy-Rim_Front-Right-Side": "Front alloy rim",
  "Alloy-Rim_Rear-Right-Side": "Rear alloy rim",
  "Wheel_Front-Right-Side": "Front wheel",
  "Wheel_Rear-Right-Side": "Rear wheel",
  "Arch-Panel_Front-Right-Side": "Front arch panel",
  "Arch-Panel_Rear-Right-Side": "Rear arch panel",
  "Exterior-Door-Handle_Front-Right-Side": "Front door handle",
  "Exterior-Door-Handle_Rear-Right-Side": "Rear door handle",
  "Quarter-Glass_Right-Side": "Quarter glass",
  "Side-Rocker-Panel_Right-Side": "Side rocker panel",
  "Molding_Right-Side": "Moldings",
  "Roof-Rail_Right-Side": "Roof rail",
  "Indicator-Light_Right-Side": "Indicator light",
  "Side-Bumper_Front-Right-Side": "Front side bumper",
  "Side-Bumper_Rear-Right-Side": "Rear side bumper",
  "Fender_Right-Side": "Fender",
  "Quarter-Panel_Right-Side": "Quarter panel",

  // Front Side
  "Bumper_Front-Side": "Bumper",
  "Grille_Front-Side": "Grille",
  "Head-Light_Left-Side": "Left head light",
  "Head-Light_Right-Side": "Right head light",
  "Fog-Light_Front-Left-Side": "Left fog light",
  "Fog-Light_Front-Right-Side": "Right fog light",
  "Windshield_Front-Side": "Windshield",
  "Wiper_Front-Side": "Wiper",
  "Logo_Front-Side": "Logo",
  Hood: "Hood",

  // Rear Side
  "Bumper_Rear-Side": "Bumper",
  "Tail-Light_Left-Side": "Left tail light",
  "Tail-Light_Right-Side": "Right tail light",
  "Fog-Light_Rear-Left-Side": "Left fog light",
  "Fog-Light_Rear-Right-Side": "Right fog light",
  "Windshield_Rear-Side": "Windshield",
  "Wiper_Rear-Side": "Wiper",
  Spoiler: "Spoiler",
  Trunk: "Trunk",
  "License-Plate": "License plate",
  "Brake-Light": "Brake light",
  "Logo_Rear-Side": "Logo",
  "Grille_Rear-Side": "Grille",
  Antenna: "Antenna",

  // Shared / Common
  "Fuel-Cap": "Fuel cap",
  Roof: "Roof",
};
export const templates: Record<SideKey, { sn: number; part: string }[]> = {
  "left-side": [
    { sn: 1, part: "Indicator light" },
    { sn: 2, part: "Fender" },
    { sn: 3, part: "Quarter panel" },
    { sn: 4, part: "Side rocker panel" },
    { sn: 5, part: "Front arch panel" },
    { sn: 6, part: "Rear arch panel" },
    { sn: 7, part: "Front door" },
    { sn: 8, part: "Rear door" },
    { sn: 9, part: "Moldings" },
    { sn: 10, part: "Front door handle" },
    { sn: 11, part: "Rear door handle" },
    { sn: 12, part: "Fuel cap" },
    { sn: 13, part: "Side mirror" },
    { sn: 14, part: "Front window" },
    { sn: 15, part: "Rear window" },
    { sn: 16, part: "Quarter glass" },
    // { sn: 19, part: "Front alloy rim" },
    // { sn: 20, part: "Rear alloy rim" },
    // { sn: 21, part: "Front wheel" },
    // { sn: 22, part: "Rear wheel" },
    { sn: 17, part: "Roof rail" },
  ],
  "right-side": [
    { sn: 1, part: "Indicator light" },
    { sn: 2, part: "Fender" },
    { sn: 3, part: "Quarter panel" },
    { sn: 4, part: "Side rocker panel" },
    { sn: 5, part: "Front arch panel" },
    { sn: 6, part: "Rear arch panel" },
    { sn: 7, part: "Front door" },
    { sn: 8, part: "Rear door" },
    { sn: 9, part: "Moldings" },
    { sn: 10, part: "Front door handle" },
    { sn: 11, part: "Rear door handle" },
    { sn: 12, part: "Side mirror" },
    { sn: 13, part: "Front window" },
    { sn: 14, part: "Rear window" },
    { sn: 15, part: "Quarter glass" },
    // { sn: 18, part: "Front alloy rim" },
    // { sn: 19, part: "Rear alloy rim" },
    // { sn: 20, part: "Front wheel" },
    // { sn: 21, part: "Rear wheel" },
    { sn: 16, part: "Roof rail" },
  ],
  "front-side": [
    { sn: 1, part: "Bumper" },
    { sn: 2, part: "Grille" },
    { sn: 3, part: "Right fog light" },
    { sn: 4, part: "Left fog light" },
    { sn: 5, part: "Right head light" },
    { sn: 6, part: "Left head light" },
    { sn: 7, part: "Hood" },
    { sn: 8, part: "Logo" },
    { sn: 9, part: "Windshield" },
    { sn: 10, part: "Wiper" },
    { sn: 11, part: "Roof" },
  ],
  "rear-side": [
    { sn: 1, part: "Bumper" },
    { sn: 2, part: "License plate" },
    { sn: 3, part: "Right fog light" },
    { sn: 4, part: "Left fog light" },
    { sn: 5, part: "Right tail light" },
    { sn: 6, part: "Left tail light" },
    { sn: 7, part: "Brake light" },
    { sn: 8, part: "Logo" },
    { sn: 9, part: "Windshield" },
    { sn: 10, part: "Wiper" },
    { sn: 11, part: "Spoiler" },
    { sn: 12, part: "Trunk" },
    { sn: 13, part: "Grille" },
    { sn: 14, part: "Antenna" },
  ],
  wheels: [
    { sn: 1, part: "Front left wheel" },
    { sn: 2, part: "Front right wheel" },
    { sn: 3, part: "Rear left wheel" },
    { sn: 4, part: "Rear right wheel" },
  ],
};
